import styled, { css } from 'styled-components';
import { rem } from 'polished';
import { CardTitle } from 'reactstrap';
import { fontStyle, fontWeight, lineHeight } from '@whitelabel/helpers/style/type';
import { gray, color } from '@whitelabel/helpers/style/colors';
import { borderRadius } from '@whitelabel/helpers/style/box';
import { mediaBreakpointUp } from '@whitelabel/helpers/style/grid';

const borderTopRadius = css`
  border-top-left-radius: ${borderRadius('base')};
  border-top-right-radius: ${borderRadius('base')};
`;

export const StyledPartnerHeader = styled(CardTitle).attrs(() => ({ tag: 'div' }))`
  width: 100%;
  ${borderTopRadius}
  margin-bottom: 0;
  .btn-close {
    color: ${color('white')};
    opacity: 1;
  }
  .modal-header {
    ${borderTopRadius}
    background: ${color('ceruleanGradient')};
    height: ${rem(83)};
    margin-bottom: 0;
    text-align: center;
    position: relative;
    h1 {
      overflow-wrap: break-word;
      color: ${color('white')};
      margin-bottom: 0;
      text-transform: none;
      ${fontStyle('secondaryH2')};
    }
    .btn-return {
      cursor: pointer;
      border: none;
      color: ${color('white')};
      position: absolute;
      top: 50%;
      transform: translateY(-50%);
      left: 0;
      width: auto;
      height: auto;
      margin: 0;
      padding: 1rem;
      font-weight: ${fontWeight('headings')};
      font-size: 1.5rem;
      line-height: 0.5;
      background: none;
      ${mediaBreakpointUp('md')`
        left: 1rem;
      `}
    }
  }
`;

export const StyledPartnerInfo = styled.div`
  width: 100%;
  background: ${gray(200)};
  height: ${rem(111)};
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 1rem;
  ${mediaBreakpointUp('md')`
    height: ${rem(83)};
  `}
  h2 {
    ${fontStyle('secondaryH4')};
    text-transform: none;
    color: ${gray(700)};
    line-height: ${lineHeight('headingsLg')};
    position: relative;
    text-align: center;
    ${mediaBreakpointUp('md')`
      position: absolute;
      margin-top:0; 
      left: 2.5rem;
      top: 50%;
      transform: translateY(-50%);
    `}
  }
  .image-wrapper {
    position: relative;
    margin: auto;
    width: 5.5rem;
    user-select: none;
    pointer-events: none;
    text-align: center;

    ${mediaBreakpointUp('md')`
      position: absolute;
      width: 5.5rem;
      right: 2.5rem;  
      top: 50%;
      transform: translateY(-50%);   
    `}

    img {
      max-height: 4rem;
    }
  }
`;
